import React, {Component} from 'react';
import {bool, func, object, oneOf, oneOfType, string} from "prop-types";
import "features/components/button/index.scss";
import {Icon} from "features/components/icon";

export default class Button extends Component {



    render() {
        const size = this.props.size || "default-size";
        const type = this.props.type || "default-type";
        const status = this.props.status || "default-status";
        const disabled = this.props.disabled ? "disabled" : "";
        const hasIcon = this.props.icon ? "has-icon" : ""
        const {onClick, icon, title} = this.props;
        return (
            <div className={["button", size, type, status, disabled, hasIcon, this.props.className || ""].join(" ")} onClick={() => onClick()}>
                <span className="content">
                    <p>{title}</p>
                    {status === "loading" && <Icon>loader</Icon>}
                    {status !== "loading" && icon && <Icon>{icon}</Icon>}
                </span>
            </div>
        )
    }
}

Button.propTypes = {
    title: oneOfType([string, object]).isRequired,
    onClick: func.isRequired,
    size: oneOf(["default-size", "small"]),
    type: oneOf(["default-type", "accent", "outlined", "clear", "square"]),
    disabled: bool,
    status: oneOf(["default-status", "success", "danger", "loading", "fab"]),
    icon: string,
    className: string
}